import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saGtpDataVolumeCellChartConfig } from '../cellChartConfigs';

interface GtpDataVolumeSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const GtpDataVolumeSaCell: React.FC<GtpDataVolumeSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saGtpDataVolumeCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default GtpDataVolumeSaCell;
